import { useTranslation } from 'react-i18next'
import { isCartillaSubdomain } from '../utils/links'

const Cartilla404 = () => {
  const { t } = useTranslation()
  
  // Detectar si estamos en cartilla o wiri
  const isCartilla = isCartillaSubdomain()
  
  // Link de home según el dominio
  const homeLink = isCartilla ? 'https://drapp.la' : 'https://wiri.la'
  const homeText = isCartilla ? 'drapp.la' : 'wiri.la'

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
        <div className="mb-6">
          <svg 
            className="mx-auto h-12 w-12 text-gray-400" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.47-.881-6.08-2.33" 
            />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {t('page_not_found', 'Página no encontrada')}
        </h1>
        
        <p className="text-gray-600 mb-6">
          {isCartilla 
            ? t('page_not_available_cartilla', 'Esta página no está disponible en la cartilla de profesionales.')
            : t('page_not_available_wiri', 'Esta página no está disponible.')
          }
        </p>
        
        {isCartilla && (
          <div className="space-y-3">
            <p className="text-sm text-gray-500">
              {t('cartilla_info', 'La cartilla de profesionales permite a los pacientes tomar turnos directamente con equipos y profesionales.')}
            </p>
          </div>
        )}
        
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            {isCartilla 
              ? t('access_other_drapp_features', 'Si necesitas acceder a otras funcionalidades de DrApp, visita')
              : t('access_other_wiri_features', 'Si necesitas acceder a otras funcionalidades de Wiri, visita')
            }{' '}
            <a href={homeLink} className="text-blue-600 hover:text-blue-800">
              {homeText}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Cartilla404
